/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { FormlyFieldConfig } from '@ngx-formly/core';

export function readonlyExtension(field: FormlyFieldConfig) {
  if (field && field.templateOptions && field.templateOptions.readOnly === undefined) {
    if (
      !field.options ||
      !field.options.formState ||
      !field.options.formState.readOnly ||
      !field.key ||
      (field.wrappers && field.wrappers.indexOf('readonly') !== -1)
    ) {
      return;
    }
  }
  field.wrappers = ['readonly', ...(field.wrappers || [])];
}
